import { adjustTitleFromSlug } from '@/mixins/lib/textFormat'
import { getAliasesByMode } from './routesAlias'

// Create titles based on the given {mode} 
export const createTitles = (mode = 'discover', base = '') => {
    
    // Get the proper {alias} array
    const titles = getAliasesByMode(mode)

    // Return properly adjusted <title>
    if (!base || mode == 'discover') {
        return titles.map(title => adjustTitleFromSlug(title))
    }
    return titles.map(title => `${base} ${adjustTitleFromSlug(title)}`)
}

// Create route aliases based on the given {mode} 
export const createAlias = (mode = 'discover', base = '') => {

    // Get the proper {alias} array
    const titles = getAliasesByMode(mode)

    // Return properly adjusted route
    if (!base || mode == 'discover') {
        return titles.map((route) => `/${route}`)
    }
    return titles.map((route) => `/${base}-${route}`)
}